import React, { useMemo, useState } from 'react'
import './Drenagem.scss'
import { Header, Icon, Table, Button, Modal, Radio, Form, Breadcrumb } from 'semantic-ui-react'
// import { GlobalContext } from 'globalContext'
import { useSubscription } from 'utils'
import request from 'services/http'
import { tap } from 'rxjs/operators'
import { DateTime } from 'luxon'

export default function RelatorioGeral() {

    // const [globalState] = useContext(GlobalContext)
    const [drainages, setDrainages] = useState([])
    // const unidades = useMemo(() => (globalState.empresas || []).filter(x => x.tipo === 'POSTO'), [globalState])

    const getDrainages$ = useMemo(() => request({ method: 'GET', url: '/combustivel/drenagem' }).pipe(
        tap(({ response }) => setDrainages(response))
    ), [])
    useSubscription(getDrainages$)

    return (
        <>
            <Modal size='tiny' open={false} dimmer='blurring'>
                <Modal.Header><Icon name='lock open' /> Desbloquear Lançamento</Modal.Header>
                <Modal.Content>
                    <Form>
                        <Form.Field>Operador alegou:</Form.Field>
                        <Form.Field>
                            <Radio label='Chuva' />
                        </Form.Field>
                        <Form.Field>
                            <Radio label='Chuva' />
                        </Form.Field>
                    </Form>
                </Modal.Content>
                <Modal.Actions style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                        positive
                        icon='thumbs up'
                        labelPosition='right'
                        content='Obrigado'
                        onClick={() => { }}
                    />
                </Modal.Actions>
            </Modal>
            <div id="drenagem-relatorio-geral" className='style-2'>
                <Breadcrumb size='mini' icon='right angle' sections={[
                    { key: 'home', content: 'Home', link: true },
                    { key: 'combustivel', content: 'Combustível', link: true },
                    { key: 'drenagem', content: 'Drenagem', active: true }
                ]} />
                <div id="content">
                    <Header size='medium' as='h2'>
                        <Icon name='rocket' />
                        <Header.Content>Drenagem de Combustível
                                <Header.Subheader style={{ fontSize: 15 }}>Menu</Header.Subheader>
                        </Header.Content>
                    </Header>

                    <Table>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Lançado Em</Table.HeaderCell>
                                <Table.HeaderCell>Unidade</Table.HeaderCell>
                                <Table.HeaderCell>Usuário</Table.HeaderCell>
                                <Table.HeaderCell>Lançamentos/Tanques Und.</Table.HeaderCell>
                                <Table.HeaderCell>Status</Table.HeaderCell>
                                <Table.HeaderCell></Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {drainages.map((x, i) => (
                                <Table.Row key={i}>
                                    <Table.Cell>{DateTime.fromSQL(x.created_at).toFormat('dd/MM/yyyy HH:mm')}</Table.Cell>
                                    <Table.Cell>{x.unidade_cod} - {x.unidade_nome}</Table.Cell>
                                    <Table.Cell></Table.Cell>
                                    <Table.Cell>{x.tanques_lancados}/{x.tanques}</Table.Cell>
                                    <Table.Cell>{x.last_log_id}</Table.Cell>
                                    <Table.Cell>
                                        <Button size='mini' icon='lock open' />
                                    </Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                </div>
            </div>
        </>
    )
}
